module.exports = __webpack_public_path__ + "static/media/31JFA10.cf8bdd11.jpg";